module.exports = __webpack_public_path__ + "static/media/04_crisalide.ecefc1b1.jpg";